/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  getHandoverChecklist,
  handoverToCustomerProperty,
  reqToEmptyHandoverChecklist,
} from "../../store/slice/handoverChecklistSlice";
import { toast } from "react-toastify";
import Button from "../../component/Common/Button";
import Select from "react-select";
import { getprojectId } from "../../store/slice/projectSlice";

const EditAssignedHandoverChecklist = ({ isEditOpen, handoverData }) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const [data, setData] = useState({});
  const [page, setPage] = useState(1);
  const [handoverOptions, setHandoverOptions] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const handoverchecklist = useSelector(
    (state) => state?.handoverChecklist?.handoverchecklist
  );
  const { project } = useSelector((state) => state.project);
  const [handoverTitles, setHandoverTitles] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  // See AssignHandoverChecklist — synchronous guard, state alone is too slow.
  const submittingRef = useRef(false);

  const fetchHandoverChecklist = async (newPage) => {
    if (!hasMore || loading) return; // Stop if no more data or already loading
    setLoading(true);

    const response = await dispatch(
      getHandoverChecklist({ project_id: id })
    ).unwrap();

    if (response?.data.length > 0) {
      setHandoverOptions((prev) => [
        ...prev,
        ...response?.data
          ?.filter(
            (checklist) =>
              checklist?.handover_status === true &&
              checklist?.project_name === project?.name
          )
          ?.map((item) => ({
            value: String(item.id),
            label: item.title,
          })),
      ]);
    } else {
      setHasMore(false); // No more data available
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchHandoverChecklist(1)
    dispatch(getprojectId(id));
    if (handoverData) {
      // Pre-fill handoverTitles with already assigned handover item titles
      setHandoverTitles(handoverData?.handovers?.map((item) => item.handover_title));
    }
    return () => {
      dispatch(reqToEmptyHandoverChecklist([]))
    }
  }, [dispatch, handoverData]);

  const handleHandoverTitleChange = async (selectedOptions) => {
    if (selectedOptions.some((option) => option.value === "select_all")) {
      dispatch(reqToEmptyHandoverChecklist([]))
      try {
        const response = await dispatch(getHandoverChecklist({ project_id: id })).unwrap();
        const handoverChecklistOptions = response?.data
          ?.filter(
            (checklist) =>
              checklist?.handover_status === true &&
              checklist?.project_name === project?.name
          )
          ?.map((item) => ({
            value: item.id,
            label: item.title,
          }));
        setHandoverOptions(handoverChecklistOptions);
        setHandoverTitles(handoverChecklistOptions?.map((option) => option.label));
      } catch (error) {
        console.log("Error Fetching possession checklist", error);

      }
    } else if (selectedOptions.some((option) => option.value === "deselect_all")) {
      setHandoverTitles([]);
    } else {
      setHandoverTitles(selectedOptions.map((option) => option.label));
    }
  };

  // const handleHandoverCheck = (event) => {
  //   const { value, checked } = event.target;
  //   setHandoverTitles((prev) =>
  //     checked ? [...prev, value] : prev.filter((item) => item !== value)
  //   );
  // };
  useEffect(() => {
    setData({
      handover_ids: handoverchecklist
        ?.filter((item) => handoverTitles?.includes(item.title))
        ?.map((item) => String(item.id)),
      customer_property_ids: [handoverData?.id],
      action: "edit",
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handoverTitles, handoverchecklist]);

  const handleUpdateHandover = async (e) => {
    e.preventDefault();
    if (submittingRef.current) return; // already in flight, ignore extra clicks

    if (handoverTitles?.length > 0) {
      submittingRef.current = true;
      setIsSubmitting(true);
      dispatch(
        handoverToCustomerProperty({
          id,
          data,
          onSuccess: () => {
            submittingRef.current = false;
            setIsSubmitting(false);
            toast.success("Possession Updated Successfully", {
              autoClose: 1500,
            });
            isEditOpen(); // Close the form
          },
          onFailure: (err) => {
            submittingRef.current = false;
            setIsSubmitting(false);
            console.log(err);
            toast.error(err?.response?.data?.message || "Update Failed", {
              autoClose: 2000,
            });
          },
        })
      );
    } else {
      toast.error("Please select at least one possession item");
    }
  };

  const handleScrollBottom = (e) => {
    if (hasMore && !loading && handoverchecklist.length === 20) {
      setPage((prev) => prev + 1);
      fetchHandoverChecklist(page + 1);
    }
  };

  return (
    <div className="project_edit_main_content center_table_body">
      <button
        className="comman_btn"
        style={{ marginBottom: "15px" }}
        onClick={isEditOpen}
        disabled={isSubmitting}
      >
        Back to Possession
      </button>
      <div className="create_from_row">
        <h3>Edit Possession Items</h3>
        <div className="contact_property_main_wrapper">
          <div
            className="create_from_checkbox_content"
            style={{
              display: "flex",
              gap: "10px",
              flexWrap: "wrap",
              marginBottom: "20px",
            }}
          >
            <Select
              className="basic-multi-select"
              classNamePrefix="select"
              placeholder={
                handoverOptions?.length === 0
                  ? "No Checklist Available"
                  : "Select Possession Items..."
              }
              isMulti
              options={
                handoverOptions?.length > 0 ? (handoverTitles.length !== handoverOptions.length
                  ? [
                    { value: "select_all", label: "Select All" },
                    ...handoverOptions,
                  ] : [{ value: "deselect_all", label: "Remove All" }])
                  : [{ value: "no_checklist", label: "No Checklist Available" }]
              }
              onChange={handleHandoverTitleChange}
              value={handoverOptions?.filter((option) =>
                handoverTitles?.includes(option.label)
              )}
              menuPortalTarget={document?.body}
              isDisabled={handoverOptions?.length === 0} // Disable select if no options
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
                // .basic-multi-select has no width of its own, so inside the
                // flex row the control collapses to the typed text width.
                container: (base) => ({
                  ...base,
                  width: "100%",
                }),
              }}
              onMenuScrollToBottom={handleScrollBottom}
            />
            {/* {handoverTitles.length > 0 && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  flexWrap: "wrap",
                }}  
              >
                <h4>Selected Handovers: </h4>
                {handoverTitles.map((title, index) => (
                  <div key={index}>{title},</div>
                ))}
              </div>
            )} */}
          </div>
          <hr />
        </div>

        <h4>Property: {handoverData?.property_number}</h4>

        <Button
          className="create_from_bottom_btn col_span_2"
          buttonClassName="comman_btn"
          type="button"
          onClick={handleUpdateHandover}
          isDisabled={isSubmitting}
          text={isSubmitting ? "Updating Possession..." : "Edit Possession"}
        />
      </div>
    </div>
  );
};

export default EditAssignedHandoverChecklist;
